import React, { useEffect, useState } from 'react'
import { withPlugin } from '@flamingo_tech/funkgo'
import styles from './CartBuoy.module.css'
import cx from '../../../utils/className'
import Pressable from '../../common/Pressable/Pressable'


const AddCartTip = props => {
  const [show, setShow] = useState(false)
  const [num, setNum] = useState(0)

  useEffect(() => {
    setNum(props.itemQuantity)
  }, [props.itemQuantity])

  useEffect(() => {
    if (props.hasAddCart && num !== props.itemQuantity) {
      setTimeout(() => {
        setShow(true)
        setTimeout(() => {
          setShow(false)
        }, 800)
      }, 300)
    }
  }, [props, num])

  if (!show) {
    return null
  }

  return <div className={cx(styles.addCart)} >+1</div>
}

class CartBuoy extends React.Component {
  render() {
    const { cartLineItemCount, onClick = () => {} } = this.props
    const cart = this.props.cart || {}
    const cartOperation = this.props.cartOperation || {}

    return (
      <Pressable
        className={cx(styles.buoyWrapper)}
        onClick={onClick}
        id="atc_parabola_destination_main"
        ariaLabel={this.props.$i18n.transl('core.cart.shoppingCart')}
      >
        <AddCartTip itemQuantity={cart.itemQuantity} hasAddCart={cart.itemQuantity > 0 && cartOperation.add} />
        <div className={styles.icon} aria-hidden="true">&#xe61c;</div>
        {
          cartLineItemCount > 0 &&
          <div className={styles.count} aria-hidden="true">{cartLineItemCount > 99 ? '99+': cartLineItemCount}</div>
        }
      </Pressable>
    )
  }
}

export default withPlugin(CartBuoy)
